import { render, staticRenderFns } from "./qc-ppbkl.vue?vue&type=template&id=484971be&scoped=true"
import script from "./qc-ppbkl.vue?vue&type=script&lang=js"
export * from "./qc-ppbkl.vue?vue&type=script&lang=js"
import style0 from "./qc-ppbkl.vue?vue&type=style&index=0&id=484971be&prod&lang=scss"
import style1 from "./qc-ppbkl.vue?vue&type=style&index=1&id=484971be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484971be",
  null
  
)

export default component.exports